import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import '@/assets/less/common.less';

import i18n from './locales';

createApp(App).use(router).use(i18n).mount('#app');
